<div class="d-lg-none">
  <div class="toolbar-logo">
    <img src="/assets/image/Hogia-logo-small.png" />
    <h5>DinHyresvärd</h5>
  </div>
</div>

<div class="pull-right">
  <div class="no-print d-none d-lg-inline-block menu-button" (click)="closeMenus()">
    <a routerLink="/dh/help" class="help-link">
      <img src="assets/icons/toolbar/question-circle.svg" />
      {{ 'HELP_TEXT' | translate }}
    </a>
  </div>

  <div class="d-none d-lg-inline-block menu-button" (click)="closeUserAccountMenu()">
    <app-language-select></app-language-select>
  </div>

  <div class="menu-button" (click)="closeLanguageMenu()">
    <app-user-account-menu [isAdmin]="isAdmin$ | async"></app-user-account-menu>
  </div>
  <div>
    @if (userAccountMenu?.hasBreachedLimits) {
      <i
        class="fa-solid fa-triangle-exclamation limits-maxed-out-indicator"
        aria-hidden="true"
        [attr.title]="'LICENSE_LIMIT.LIMITS_BREACHED_ICON' | translate"
        ><span class="screen-reader-only">{{ 'LICENSE_LIMIT.LIMITS_BREACHED_ICON' | translate }}</span></i
        >
      }
    </div>
    <div class="d-lg-none menu-button" (click)="handleOpenNavigation()">
      <img class="menu-burger" src="/assets/icons/toolbar/bars.svg" />
    </div>
  </div>
